const ArrowLeft = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowRight = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const QuizNavigation = ({ onBack, onNext, showBack, canGoNext }) => {
  return (
    <div className="mt-4 flex items-center justify-between">
      <div>
        {showBack && (
          <button
            type="button"
            onClick={onBack}
            className="hover:border-brand-400 hover:text-brand-400 flex h-[61px] w-[61px] cursor-pointer items-center justify-center rounded-full border-3 border-white text-white transition-colors"
          >
            <ArrowLeft />
          </button>
        )}
      </div>
      <button
        type="button"
        onClick={onNext}
        disabled={!canGoNext}
        className="hover:border-brand-400 hover:text-brand-400 flex h-[61px] w-[61px] cursor-pointer items-center justify-center rounded-full border-3 border-white text-white transition-colors disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:border-white disabled:hover:text-white"
      >
        <ArrowRight />
      </button>
    </div>
  );
};

export default QuizNavigation;
